import { deleteOrderSale, getCreate, getOrdersSale, receiveOrderSale, saveOrderSale, assignOrderSale } from "@/api/Purchases/orders_sale";
import { useQuery, useMutation, useQueryClient } from "react-query";
import _ from "lodash";

const key = "purchase_orders_sale";

export function useOrderSalePaginate(params) {
	return useQuery([key, { ...params }], () => getOrdersSale(params));
}

export function useOrderSaleCreate(params) {
	return useQuery([key, { ...params }], () => getCreate(params));
}

export function useOrderSaleSave(base, params) {
	const queryClient = useQueryClient();

	return useMutation(saveOrderSale, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_sale");
			const detail = response.order_sale;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order_sale = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}

			queryClient.removeQueries([key, { ...params }]);
			queryClient.removeQueries(["dashboard_valorization"]);
			queryClient.removeQueries(["dashboard_sales"]);
			queryClient.removeQueries(["dashboard_sales_dealer"]);
			queryClient.removeQueries(["pending-approval"]);
		},
	});
}

export function useOrderSaleDelete(base, params) {
	const queryClient = useQueryClient();

	return useMutation(deleteOrderSale, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_sale");
			const detail = response.order;

			queryClient.setQueryData([key, { ...base }], list);
			const query_data = { ...queryClient.getQueryData([key, { ...params }]) };

			if (detail) {
				query_data.order = detail;
				queryClient.setQueryData([key, { ...params }], query_data);
			}
		},
	});
}

export function useOrderSaleReceive(base) {
	const queryClient = useQueryClient();

	return useMutation(receiveOrderSale, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_sale");
			queryClient.setQueryData([key, { ...base }], list);
		},
	});
}

export function useOrderSaleConfirmAssign(base) {
	const queryClient = useQueryClient();

	return useMutation(assignOrderSale, {
		onSuccess: (response) => {
			const list = _.omit(response, "order_sale");
			queryClient.setQueryData([key, { ...base }], list);
		},
	});
}
